import { Badge } from "../../ui/badge";

// TRACKED (the product sends this event today) or PLANNED (it is in the list and nothing sends it yet), as the Paper table and panel draw it. The
// word is always there: PLANNED also has a dashed outline, so the difference is never colour alone.
export function StatusPill({ status }: Readonly<{ status: "TRACKED" | "PLANNED" }>) {
  return status === "TRACKED" ? (
    <Badge tone="success" className="px-1.5 py-0.5 text-[10px] font-bold tracking-[0.04em]">
      TRACKED
    </Badge>
  ) : (
    <Badge
      tone="outline"
      className="border-dashed px-1.5 py-0.5 text-[10px] font-bold tracking-[0.06em]"
    >
      PLANNED
    </Badge>
  );
}
